window.reparacoesData = {
  // —— Linha Poco ——
  "poco-f5": {
    "Display/Touch": [
      { nome: "Substituição de Display/Touch", preco: "129,90€" }
    ],
    "Bateria": [
      { nome: "Troca de Bateria", preco: "Sob consulta" }
    ],
    "Conector de Carga": [
      { nome: "Reparação do Conector de Carga", preco: "Sob consulta" }
    ],
    "Câmara frontal": [
      { nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }
    ],
    "Câmara Traseira": [
      { nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }
    ],
    "Tampa Traseira": [
      { nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }
    ],
    "Descreve a avaria": [
      { nome: "Orçamento Personalizado", preco: "Sob consulta" }
    ]
  },
  "poco-x5-5g": {
    "Display/Touch": [
      { nome: "Substituição de Display/Touch", preco: "Sob consulta" }
    ],
    "Bateria": [
      { nome: "Troca de Bateria", preco: "Sob consulta" }
    ],
    "Conector de Carga": [
      { nome: "Reparação do Conector de Carga", preco: "Sob consulta" }
    ],
    "Câmara frontal": [
      { nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }
    ],
    "Câmara Traseira": [
      { nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }
    ],
    "Tampa Traseira": [
      { nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }
    ],
    "Descreve a avaria": [
      { nome: "Orçamento Personalizado", preco: "Sob consulta" }
    ]
  },
  "poco-m5s": {
    "Display/Touch": [
      { nome: "Substituição de Display/Touch", preco: "Sob consulta" }
    ],
    "Bateria": [
      { nome: "Troca de Bateria", preco: "Sob consulta" }
    ],
    "Conector de Carga": [
      { nome: "Reparação do Conector de Carga", preco: "Sob consulta" }
    ],
    "Câmara frontal": [
      { nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }
    ],
    "Câmara Traseira": [
      { nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }
    ],
    "Tampa Traseira": [
      { nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }
    ],
    "Descreve a avaria": [
      { nome: "Orçamento Personalizado", preco: "Sob consulta" }
    ]
  },
  "poco-m5": {
    "Display/Touch": [
      { nome: "Substituição de Display/Touch", preco: "69,90€" }
    ],
    "Bateria": [
      { nome: "Troca de Bateria", preco: "Sob consulta" }
    ],
    "Conector de Carga": [
      { nome: "Reparação do Conector de Carga", preco: "Sob consulta" }
    ],
    "Câmara frontal": [
      { nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }
    ],
    "Câmara Traseira": [
      { nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }
    ],
    "Tampa Traseira": [
      { nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }
    ],
    "Descreve a avaria": [
      { nome: "Orçamento Personalizado", preco: "Sob consulta" }
    ]
  },
  "poco-f4": {
    "Display/Touch": [
      { nome: "Substituição de Display/Touch", preco: "159,90€" }
    ],
    "Bateria": [
      { nome: "Troca de Bateria", preco: "49,90€" }
    ],
    "Conector de Carga": [
      { nome: "Reparação do Conector de Carga", preco: "Sob consulta" }
    ],
    "Câmara frontal": [
      { nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }
    ],
    "Câmara Traseira": [
      { nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }
    ],
    "Tampa Traseira": [
      { nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }
    ],
    "Descreve a avaria": [
      { nome: "Orçamento Personalizado", preco: "Sob consulta" }
    ]
  },
  "poco-x4-gt": {
    "Display/Touch": [
      { nome: "Substituição de Display/Touch", preco: "Sob consulta" }
    ],
    "Bateria": [
      { nome: "Troca de Bateria", preco: "Sob consulta" }
    ],
    "Conector de Carga": [
      { nome: "Reparação do Conector de Carga", preco: "Sob consulta" }
    ],
    "Câmara frontal": [
      { nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }
    ],
    "Câmara Traseira": [
      { nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }
    ],
    "Tampa Traseira": [
      { nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }
    ],
    "Descreve a avaria": [
      { nome: "Orçamento Personalizado", preco: "Sob consulta" }
    ]
  },
  "poco-c40": {
    "Display/Touch": [
      { nome: "Substituição de Display/Touch", preco: "79,90€" }
    ],
    "Bateria": [
      { nome: "Troca de Bateria", preco: "Sob consulta" }
    ],
    "Conector de Carga": [
      { nome: "Reparação do Conector de Carga", preco: "Sob consulta" }
    ],
    "Câmara frontal": [
      { nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }
    ],
    "Câmara Traseira": [
      { nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }
    ],
    "Tampa Traseira": [
      { nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }
    ],
    "Descreve a avaria": [
      { nome: "Orçamento Personalizado", preco: "Sob consulta" }
    ]
  },
  "poco-f4-gt": {
    "Display/Touch": [
      { nome: "Substituição de Display/Touch", preco: "129,90€" }
    ],
    "Bateria": [
      { nome: "Troca de Bateria", preco: "49,90€" }
    ],
    "Conector de Carga": [
      { nome: "Reparação do Conector de Carga", preco: "Sob consulta" }
    ],
    "Câmara frontal": [
      { nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }
    ],
    "Câmara Traseira": [
      { nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }
    ],
    "Tampa Traseira": [
      { nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }
    ],
    "Descreve a avaria": [
      { nome: "Orçamento Personalizado", preco: "Sob consulta" }
    ]
  },
  "poco-x4-pro-5g": {
    "Display/Touch": [
      { nome: "Substituição de Display/Touch", preco: "179,90€" }
    ],
    "Bateria": [
      { nome: "Troca de Bateria", preco: "Sob consulta" }
    ],
    "Conector de Carga": [
      { nome: "Reparação do Conector de Carga", preco: "49,90€" }
    ],
    "Câmara frontal": [
      { nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }
    ],
    "Câmara Traseira": [
      { nome: "Substituição da Câmara Traseira", preco: "49,90€" }
    ],
    "Tampa Traseira": [
      { nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }
    ],
    "Descreve a avaria": [
      { nome: "Orçamento Personalizado", preco: "Sob consulta" }
    ]
  },
  "poco-m4-pro-5g": {
    "Display/Touch": [
      { nome: "Substituição de Display/Touch", preco: "Sob consulta" }
    ],
    "Bateria": [
      { nome: "Troca de Bateria", preco: "Sob consulta" }
    ],
    "Conector de Carga": [
      { nome: "Reparação do Conector de Carga", preco: "44,90€" }
    ],
    "Câmara frontal": [
      { nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }
    ],
    "Câmara Traseira": [
      { nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }
    ],
    "Tampa Traseira": [
      { nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }
    ],
    "Descreve a avaria": [
      { nome: "Orçamento Personalizado", preco: "Sob consulta" }
    ]
  },
  "poco-x3-gt": {
    "Display/Touch": [
      { nome: "Substituição de Display/Touch", preco: "119,90€" }
    ],
    "Bateria": [
      { nome: "Troca de Bateria", preco: "Sob consulta" }
    ],
    "Conector de Carga": [
      { nome: "Reparação do Conector de Carga", preco: "Sob consulta" }
    ],
    "Câmara frontal": [
      { nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }
    ],
    "Câmara Traseira": [
      { nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }
    ],
    "Tampa Traseira": [
      { nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }
    ],
    "Descreve a avaria": [
      { nome: "Orçamento Personalizado", preco: "Sob consulta" }
    ]
  },
  "poco-x3-pro": {
    "Display/Touch": [
      { nome: "Substituição de Display/Touch", preco: "109,90€" }
    ],
    "Bateria": [
      { nome: "Troca de Bateria", preco: "44,90€" }
    ],
    "Conector de Carga": [
      { nome: "Reparação do Conector de Carga", preco: "39,90€" }
    ],
    "Câmara frontal": [
      { nome: "Substituição da Câmara Frontal", preco: "59,90€" }
    ],
    "Câmara Traseira": [
      { nome: "Substituição da Câmara Traseira", preco: "49,90€" }
    ],
    "Tampa Traseira": [
      { nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }
    ],
    "Descreve a avaria": [
      { nome: "Orçamento Personalizado", preco: "Sob consulta" }
    ]
  },
  "poco-f3": {
    "Display/Touch": [
      { nome: "Substituição de Display/Touch", preco: "149,90€" }
    ],
    "Bateria": [
      { nome: "Troca de Bateria", preco: "44,90€" }
    ],
    "Descreve a avaria": [
      { nome: "Orçamento Personalizado", preco: "Sob consulta" }
    ]
  },
  "poco-x3": {
    "Bateria": [
      { nome: "Troca de Bateria", preco: "39,90€" }
    ],
    "Descreve a avaria": [
      { nome: "Orçamento Personalizado", preco: "Sob consulta" }
    ]
  },
  "poco-x3-nfc": {
    "Bateria": [
      { nome: "Troca de Bateria", preco: "39,90€" }
    ],
    "Descreve a avaria": [
      { nome: "Orçamento Personalizado", preco: "Sob consulta" }
    ]
  },
  "poco-m3": {
    "Bateria": [
      { nome: "Troca de Bateria", preco: "39,90€" }
    ],
    "Descreve a avaria": [
      { nome: "Orçamento Personalizado", preco: "Sob consulta" }
    ]
  },
  "pocophone-f1": {
    "Display/Touch": [
      { nome: "Substituição de Display/Touch", preco: "59,90€" }
    ],
    "Bateria": [
      { nome: "Troca de Bateria", preco: "39,90€" }
    ],
    "Conector de Carga": [
      { nome: "Reparação do Conector de Carga", preco: "39,90€" }
    ],
    "Descreve a avaria": [
      { nome: "Orçamento Personalizado", preco: "Sob consulta" }
    ]
  },
  "poco-x3-pro-5g": {
    "Display/Touch": [
      { nome: "Substituição de Display/Touch", preco: "Sob consulta" }
    ],
    "Bateria": [
      { nome: "Troca de Bateria", preco: "44,90€" }
    ],
    "Conector de Carga": [
      { nome: "Reparação do Conector de Carga", preco: "Sob consulta" }
    ],
    "Câmara frontal": [
      { nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }
    ],
    "Câmara Traseira": [
      { nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }
    ],
    "Tampa Traseira": [
      { nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }
    ],
    "Descreve a avaria": [
      { nome: "Orçamento Personalizado", preco: "Sob consulta" }
    ]
  },

  // —— Linha Mi ——
  "mi-11i-5g": {
    "Display/Touch": [
      { nome: "Substituição de Display/Touch", preco: "Sob consulta" }
    ],
    "Bateria": [
      { nome: "Troca de Bateria",          preco: "Sob consulta" }
    ],
    "Conector de Carga": [
      { nome: "Reparação do Conector de Carga", preco: "Sob consulta" }
    ],
    "Câmara frontal": [
      { nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }
    ],
    "Câmara Traseira": [
      { nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }
    ],
    "Tampa Traseira": [
      { nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }
    ],
    "Descreve a avaria": [
      { nome: "Orçamento Personalizado",      preco: "Sob consulta" }
    ]
  },
  "mi-11-lite": {
    "Display/Touch": [
      { nome: "Substituição de Display/Touch", preco: "Sob consulta" }
    ],
    "Bateria": [
      { nome: "Troca de Bateria",          preco: "Sob consulta" }
    ],
    "Conector de Carga": [
      { nome: "Reparação do Conector de Carga", preco: "Sob consulta" }
    ],
    "Câmara frontal": [
      { nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }
    ],
    "Câmara Traseira": [
      { nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }
    ],
    "Tampa Traseira": [
      { nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }
    ],
    "Descreve a avaria": [
      { nome: "Orçamento Personalizado",      preco: "Sob consulta" }
    ]
  },
  "mi-11": {
    "Display/Touch": [
      { nome: "Substituição de Display/Touch", preco: "Sob consulta" }
    ],
    "Bateria": [
      { nome: "Troca de Bateria",          preco: "Sob consulta" }
    ],
    "Conector de Carga": [
      { nome: "Reparação do Conector de Carga", preco: "Sob consulta" }
    ],
    "Câmara frontal": [
      { nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }
    ],
    "Câmara Traseira": [
      { nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }
    ],
    "Tampa Traseira": [
      { nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }
    ],
    "Descreve a avaria": [
      { nome: "Orçamento Personalizado",      preco: "Sob consulta" }
    ]
  },
  "mi-10": {
    "Display/Touch": [
      { nome: "Substituição de Display/Touch", preco: "Sob consulta" }
    ],
    "Bateria": [
      { nome: "Troca de Bateria",          preco: "Sob consulta" }
    ],
    "Conector de Carga": [
      { nome: "Reparação do Conector de Carga", preco: "Sob consulta" }
    ],
    "Câmara frontal": [
      { nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }
    ],
    "Câmara Traseira": [
      { nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }
    ],
    "Tampa Traseira": [
      { nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }
    ],
    "Descreve a avaria": [
      { nome: "Orçamento Personalizado",      preco: "Sob consulta" }
    ]
  },
  "mi-10t-lite": {
    "Display/Touch": [
      { nome: "Substituição de Display/Touch", preco: "Sob consulta" }
    ],
    "Bateria": [
      { nome: "Troca de Bateria",          preco: "Sob consulta" }
    ],
    "Conector de Carga": [
      { nome: "Reparação do Conector de Carga", preco: "Sob consulta" }
    ],
    "Câmara frontal": [
      { nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }
    ],
    "Câmara Traseira": [
      { nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }
    ],
    "Tampa Traseira": [
      { nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }
    ],
    "Descreve a avaria": [
      { nome: "Orçamento Personalizado",      preco: "Sob consulta" }
    ]
  },
  // —— Linha Redmi ——
"redmi-13c": {
  "Display/Touch":   [{ nome: "Substituição de Display/Touch", preco: "Sob consulta" }],
  "Bateria":         [{ nome: "Troca de Bateria",             preco: "Sob consulta" }],
  "Conector de Carga":[{ nome: "Reparação do Conector de Carga", preco: "Sob consulta" }],
  "Câmara frontal":  [{ nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }],
  "Câmara Traseira": [{ nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }],
  "Tampa Traseira":  [{ nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }],
  "Descreve a avaria":[{ nome: "Orçamento Personalizado",       preco: "Sob consulta" }]
},
"redmi-12": {
  "Display/Touch":   [{ nome: "Substituição de Display/Touch", preco: "Sob consulta" }],
  "Bateria":         [{ nome: "Troca de Bateria",             preco: "Sob consulta" }],
  "Conector de Carga":[{ nome: "Reparação do Conector de Carga", preco: "Sob consulta" }],
  "Câmara frontal":  [{ nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }],
  "Câmara Traseira": [{ nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }],
  "Tampa Traseira":  [{ nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }],
  "Descreve a avaria":[{ nome: "Orçamento Personalizado",       preco: "Sob consulta" }]
},
"redmi-12c": {
  "Display/Touch":   [{ nome: "Substituição de Display/Touch", preco: "Sob consulta" }],
  "Bateria":         [{ nome: "Troca de Bateria",             preco: "Sob consulta" }],
  "Conector de Carga":[{ nome: "Reparação do Conector de Carga", preco: "Sob consulta" }],
  "Câmara frontal":  [{ nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }],
  "Câmara Traseira": [{ nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }],
  "Tampa Traseira":  [{ nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }],
  "Descreve a avaria":[{ nome: "Orçamento Personalizado",       preco: "Sob consulta" }]
},
"redmi-note-13-pro-plus-5g": {
  "Display/Touch":   [{ nome: "Substituição de Display/Touch", preco: "Sob consulta" }],
  "Bateria":         [{ nome: "Troca de Bateria",             preco: "Sob consulta" }],
  "Conector de Carga":[{ nome: "Reparação do Conector de Carga", preco: "Sob consulta" }],
  "Câmara frontal":  [{ nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }],
  "Câmara Traseira": [{ nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }],
  "Tampa Traseira":  [{ nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }],
  "Descreve a avaria":[{ nome: "Orçamento Personalizado",       preco: "Sob consulta" }]
},
"redmi-note-13-pro-5g": {
  "Display/Touch":   [{ nome: "Substituição de Display/Touch", preco: "Sob consulta" }],
  "Bateria":         [{ nome: "Troca de Bateria",             preco: "Sob consulta" }],
  "Conector de Carga":[{ nome: "Reparação do Conector de Carga", preco: "Sob consulta" }],
  "Câmara frontal":  [{ nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }],
  "Câmara Traseira": [{ nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }],
  "Tampa Traseira":  [{ nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }],
  "Descreve a avaria":[{ nome: "Orçamento Personalizado",       preco: "Sob consulta" }]
},
"redmi-note-13-5g": {
  "Display/Touch":   [{ nome: "Substituição de Display/Touch", preco: "Sob consulta" }],
  "Bateria":         [{ nome: "Troca de Bateria",             preco: "Sob consulta" }],
  "Conector de Carga":[{ nome: "Reparação do Conector de Carga", preco: "Sob consulta" }],
  "Câmara frontal":  [{ nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }],
  "Câmara Traseira": [{ nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }],
  "Tampa Traseira":  [{ nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }],
  "Descreve a avaria":[{ nome: "Orçamento Personalizado",       preco: "Sob consulta" }]
},
"redmi-note-13": {
  "Display/Touch":   [{ nome: "Substituição de Display/Touch", preco: "Sob consulta" }],
  "Bateria":         [{ nome: "Troca de Bateria",             preco: "Sob consulta" }],
  "Conector de Carga":[{ nome: "Reparação do Conector de Carga", preco: "Sob consulta" }],
  "Câmara frontal":  [{ nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }],
  "Câmara Traseira": [{ nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }],
  "Tampa Traseira":  [{ nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }],
  "Descreve a avaria":[{ nome: "Orçamento Personalizado",       preco: "Sob consulta" }]
},
"redmi-note-12t-pro": {
  "Display/Touch":   [{ nome: "Substituição de Display/Touch", preco: "Sob consulta" }],
  "Bateria":         [{ nome: "Troca de Bateria",             preco: "Sob consulta" }],
  "Conector de Carga":[{ nome: "Reparação do Conector de Carga", preco: "Sob consulta" }],
  "Câmara frontal":  [{ nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }],
  "Câmara Traseira": [{ nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }],
  "Tampa Traseira":  [{ nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }],
  "Descreve a avaria":[{ nome: "Orçamento Personalizado",       preco: "Sob consulta" }]
},
"redmi-note-12-pro-4g": {
  "Display/Touch":   [{ nome: "Substituição de Display/Touch", preco: "Sob consulta" }],
  "Bateria":         [{ nome: "Troca de Bateria",             preco: "Sob consulta" }],
  "Conector de Carga":[{ nome: "Reparação do Conector de Carga", preco: "Sob consulta" }],
  "Câmara frontal":  [{ nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }],
  "Câmara Traseira": [{ nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }],
  "Tampa Traseira":  [{ nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }],
  "Descreve a avaria":[{ nome: "Orçamento Personalizado",       preco: "Sob consulta" }]
},
"redmi-a2": {
  "Display/Touch":   [{ nome: "Substituição de Display/Touch", preco: "Sob consulta" }],
  "Bateria":         [{ nome: "Troca de Bateria",             preco: "Sob consulta" }],
  "Conector de Carga":[{ nome: "Reparação do Conector de Carga", preco: "Sob consulta" }],
  "Câmara frontal":  [{ nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }],
  "Câmara Traseira": [{ nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }],
  "Tampa Traseira":  [{ nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }],
  "Descreve a avaria":[{ nome: "Orçamento Personalizado",       preco: "Sob consulta" }]
},
"redmi-note-12-4g": {
  "Display/Touch":   [{ nome: "Substituição de Display/Touch", preco: "129,90€" }],
  "Bateria":         [{ nome: "Troca de Bateria",             preco: "Sob consulta" }],
  "Conector de Carga":[{ nome: "Reparação do Conector de Carga", preco: "Sob consulta" }],
  "Câmara frontal":  [{ nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }],
  "Câmara Traseira": [{ nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }],
  "Tampa Traseira":  [{ nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }],
  "Descreve a avaria":[{ nome: "Orçamento Personalizado",       preco: "Sob consulta" }]
},
"redmi-note-12": {
  "Display/Touch":   [{ nome: "Substituição de Display/Touch", preco: "129,90€" }],
  "Bateria":         [{ nome: "Troca de Bateria",             preco: "Sob consulta" }],
  "Conector de Carga":[{ nome: "Reparação do Conector de Carga", preco: "Sob consulta" }],
  "Câmara frontal":  [{ nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }],
  "Câmara Traseira": [{ nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }],
  "Tampa Traseira":  [{ nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }],
  "Descreve a avaria":[{ nome: "Orçamento Personalizado",       preco: "Sob consulta" }]
},
"redmi-note-12-pro-plus": {
  "Display/Touch":   [{ nome: "Substituição de Display/Touch", preco: "Sob consulta" }],
  "Bateria":         [{ nome: "Troca de Bateria",             preco: "Sob consulta" }],
  "Conector de Carga":[{ nome: "Reparação do Conector de Carga", preco: "Sob consulta" }],
  "Câmara frontal":  [{ nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }],
  "Câmara Traseira": [{ nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }],
  "Tampa Traseira":  [{ nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }],
  "Descreve a avaria":[{ nome: "Orçamento Personalizado",       preco: "Sob consulta" }]
},
"redmi-note-12-pro": {
  "Display/Touch":   [{ nome: "Substituição de Display/Touch", preco: "129,90€" }],
  "Bateria":         [{ nome: "Troca de Bateria",             preco: "Sob consulta" }],
  "Conector de Carga":[{ nome: "Reparação do Conector de Carga", preco: "Sob consulta" }],
  "Tampa Traseira":  [{ nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }],
  "Descreve a avaria":[{ nome: "Orçamento Personalizado",       preco: "Sob consulta" }]
},
"redmi-a1": {
  "Display/Touch":   [{ nome: "Substituição de Display/Touch", preco: "Sob consulta" }],
  "Bateria":         [{ nome: "Troca de Bateria",             preco: "Sob consulta" }],
  "Conector de Carga":[{ nome: "Reparação do Conector de Carga", preco: "Sob consulta" }],
  "Câmara frontal":  [{ nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }],
  "Câmara Traseira": [{ nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }],
  "Tampa Traseira":  [{ nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }],
  "Descreve a avaria":[{ nome: "Orçamento Personalizado",       preco: "Sob consulta" }]
},
"redmi-10a": {
  "Display/Touch":   [{ nome: "Substituição de Display/Touch", preco: "Sob consulta" }],
  "Bateria":         [{ nome: "Troca de Bateria",             preco: "Sob consulta" }],
  "Conector de Carga":[{ nome: "Reparação do Conector de Carga", preco: "Sob consulta" }],
  "Câmara frontal":  [{ nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }],
  "Câmara Traseira": [{ nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }],
  "Tampa Traseira":  [{ nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }],
  "Descreve a avaria":[{ nome: "Orçamento Personalizado",       preco: "Sob consulta" }]
},
"redmi-11s-5g": {
  "Display/Touch":   [{ nome: "Substituição de Display/Touch", preco: "Sob consulta" }],
  "Bateria":         [{ nome: "Troca de Bateria",             preco: "Sob consulta" }],
  "Conector de Carga":[{ nome: "Reparação do Conector de Carga", preco: "Sob consulta" }],
  "Câmara frontal":  [{ nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }],
  "Câmara Traseira": [{ nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }],
  "Tampa Traseira":  [{ nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }],
  "Descreve a avaria":[{ nome: "Orçamento Personalizado",       preco: "Sob consulta" }]
},
"redmi-10c": {
  "Display/Touch":   [{ nome: "Substituição de Display/Touch", preco: "Sob consulta" }],
  "Bateria":         [{ nome: "Troca de Bateria",             preco: "Sob consulta" }],
  "Conector de Carga":[{ nome: "Reparação do Conector de Carga", preco: "Sob consulta" }],
  "Câmara frontal":  [{ nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }],
  "Câmara Traseira": [{ nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }],
  "Tampa Traseira":  [{ nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }],
  "Descreve a avaria":[{ nome: "Orçamento Personalizado",       preco: "Sob consulta" }]
},
"redmi-10-2022": {
  "Display/Touch":   [{ nome: "Substituição de Display/Touch", preco: "Sob consulta" }],
  "Bateria":         [{ nome: "Troca de Bateria",             preco: "Sob consulta" }],
  "Conector de Carga":[{ nome: "Reparação do Conector de Carga", preco: "Sob consulta" }],
  "Câmara frontal":  [{ nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }],
  "Câmara Traseira": [{ nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }],
  "Tampa Traseira":  [{ nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }],
  "Descreve a avaria":[{ nome: "Orçamento Personalizado",       preco: "Sob consulta" }]
},
"redmi-note-11s": {
  "Display/Touch":   [{ nome: "Substituição de Display/Touch", preco: "Sob consulta" }],
  "Bateria":         [{ nome: "Troca de Bateria",             preco: "Sob consulta" }],
  "Conector de Carga":[{ nome: "Reparação do Conector de Carga", preco: "Sob consulta" }],
  "Câmara frontal":  [{ nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }],
  "Câmara Traseira": [{ nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }],
  "Tampa Traseira":  [{ nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }],
  "Descreve a avaria":[{ nome: "Orçamento Personalizado",       preco: "Sob consulta" }]
},
"redmi-note-11-pro-5g": {
  "Display/Touch":   [{ nome: "Substituição de Display/Touch", preco: "Sob consulta" }],
  "Bateria":         [{ nome: "Troca de Bateria",             preco: "Sob consulta" }],
  "Conector de Carga":[{ nome: "Reparação do Conector de Carga", preco: "Sob consulta" }],
  "Câmara frontal":  [{ nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }],
  "Câmara Traseira": [{ nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }],
  "Tampa Traseira":  [{ nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }],
  "Descreve a avaria":[{ nome: "Orçamento Personalizado",       preco: "Sob consulta" }]
},
"redmi-note-11": {
  "Display/Touch":   [{ nome: "Substituição de Display/Touch", preco: "Sob consulta" }],
  "Bateria":         [{ nome: "Troca de Bateria",             preco: "Sob consulta" }],
  "Conector de Carga":[{ nome: "Reparação do Conector de Carga", preco: "Sob consulta" }],
  "Câmara frontal":  [{ nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }],
  "Câmara Traseira": [{ nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }],
  "Tampa Traseira":  [{ nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }],
  "Descreve a avaria":[{ nome: "Orçamento Personalizado",       preco: "Sob consulta" }]
},
"redmi-note-10-5g": {
  "Display/Touch":   [{ nome: "Substituição de Display/Touch", preco: "Sob consulta" }],
  "Bateria":         [{ nome: "Troca de Bateria",             preco: "Sob consulta" }],
  "Conector de Carga":[{ nome: "Reparação do Conector de Carga", preco: "Sob consulta" }],
  "Câmara frontal":  [{ nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }],
  "Câmara Traseira": [{ nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }],
  "Tampa Traseira":  [{ nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }],
  "Descreve a avaria":[{ nome: "Orçamento Personalizado",       preco: "Sob consulta" }]
},
"redmi-note-10-pro": {
  "Display/Touch":   [{ nome: "Substituição de Display/Touch", preco: "Sob consulta" }],
  "Bateria":         [{ nome: "Troca de Bateria",             preco: "Sob consulta" }],
  "Conector de Carga":[{ nome: "Reparação do Conector de Carga", preco: "Sob consulta" }],
  "Câmara frontal":  [{ nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }],
  "Câmara Traseira": [{ nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }],
  "Tampa Traseira":  [{ nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }],
  "Descreve a avaria":[{ nome: "Orçamento Personalizado",       preco: "Sob consulta" }]
},
"redmi-note-10": {
  "Display/Touch":   [{ nome: "Substituição de Display/Touch", preco: "Sob consulta" }],
  "Bateria":         [{ nome: "Troca de Bateria",             preco: "Sob consulta" }],
  "Conector de Carga":[{ nome: "Reparação do Conector de Carga", preco: "Sob consulta" }],
  "Câmara frontal":  [{ nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }],
  "Câmara Traseira": [{ nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }],
  "Tampa Traseira":  [{ nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }],
  "Descreve a avaria":[{ nome: "Orçamento Personalizado",       preco: "Sob consulta" }]
},
"redmi-note-9t": {
  "Display/Touch":   [{ nome: "Substituição de Display/Touch", preco: "69,90€"     }],
  "Bateria":         [{ nome: "Troca de Bateria",             preco: "44,90€"     }],
  "Conector de Carga":[{ nome: "Reparação do Conector de Carga", preco: "Sob consulta" }],
  "Câmara frontal":  [{ nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }],
  "Câmara Traseira": [{ nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }],
  "Tampa Traseira":  [{ nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }],
  "Descreve a avaria":[{ nome: "Orçamento Personalizado",       preco: "Sob consulta" }]
},
"redmi-note-11-pro-plus-5g": {
  "Display/Touch":   [{ nome: "Substituição de Display/Touch", preco: "Sob consulta" }],
  "Bateria":         [{ nome: "Troca de Bateria",             preco: "Sob consulta" }],
  "Conector de Carga":[{ nome: "Reparação do Conector de Carga", preco: "Sob consulta" }],
  "Câmara frontal":  [{ nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }],
  "Câmara Traseira": [{ nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }],
  "Tampa Traseira":  [{ nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }],
  "Descreve a avaria":[{ nome: "Orçamento Personalizado",       preco: "Sob consulta" }]
},
"redmi-10": {
  "Display/Touch":   [{ nome: "Substituição de Display/Touch", preco: "89,90€"     }],
  "Bateria":         [{ nome: "Troca de Bateria",             preco: "Sob consulta" }],
  "Conector de Carga":[{ nome: "Reparação do Conector de Carga", preco: "39,90€"     }],
  "Câmara frontal":  [{ nome: "Substituição da Câmara Frontal", preco: "39,90€"     }],
  "Câmara Traseira": [{ nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }],
  "Tampa Traseira":  [{ nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }],
  "Descreve a avaria":[{ nome: "Orçamento Personalizado",       preco: "Sob consulta" }]
},
"redmi-note-8-2021": {
  "Display/Touch":   [{ nome: "Substituição de Display/Touch", preco: "Sob consulta" }],
  "Bateria":         [{ nome: "Troca de Bateria",             preco: "Sob consulta" }],
  "Conector de Carga":[{ nome: "Reparação do Conector de Carga", preco: "39,90€"     }],
  "Câmara frontal":  [{ nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }],
  "Câmara Traseira": [{ nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }],
  "Tampa Traseira":  [{ nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }],
  "Descreve a avaria":[{ nome: "Orçamento Personalizado",       preco: "Sob consulta" }]
},
"redmi-note-9-pro": {
  "Display/Touch":   [{ nome: "Substituição de Display/Touch", preco: "69,90€"     }],
  "Bateria":         [{ nome: "Troca de Bateria",             preco: "44,90€"     }],
  "Conector de Carga":[{ nome: "Reparação do Conector de Carga", preco: "Sob consulta" }],
  "Câmara frontal":  [{ nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }],
  "Câmara Traseira": [{ nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }],
  "Tampa Traseira":  [{ nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }],
  "Descreve a avaria":[{ nome: "Orçamento Personalizado",       preco: "Sob consulta" }]
},
"redmi-note-9": {
  "Display/Touch":   [{ nome: "Substituição de Display/Touch", preco: "69,90€"     }],
  "Bateria":         [{ nome: "Troca de Bateria",             preco: "44,90€"     }],
  "Conector de Carga":[{ nome: "Reparação do Conector de Carga", preco: "Sob consulta" }],
  "Câmara frontal":  [{ nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }],
  "Câmara Traseira": [{ nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }],
  "Tampa Traseira":  [{ nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }],
  "Descreve a avaria":[{ nome: "Orçamento Personalizado",       preco: "Sob consulta" }]
},
"redmi-note-9s": {
  "Display/Touch":   [{ nome: "Substituição de Display/Touch", preco: "69,90€"     }],
  "Bateria":         [{ nome: "Troca de Bateria",             preco: "44,90€"     }],
  "Conector de Carga":[{ nome: "Reparação do Conector de Carga", preco: "Sob consulta" }],
  "Câmara frontal":  [{ nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }],
  "Câmara Traseira": [{ nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }],
  "Tampa Traseira":  [{ nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }],
  "Descreve a avaria":[{ nome: "Orçamento Personalizado",       preco: "Sob consulta" }]
},
"redmi-9-at": {
  "Display/Touch":   [{ nome: "Substituição de Display/Touch", preco: "69,90€"     }],
  "Bateria":         [{ nome: "Troca de Bateria",             preco: "44,90€"     }],
  "Conector de Carga":[{ nome: "Reparação do Conector de Carga", preco: "Sob consulta" }],
  "Câmara frontal":  [{ nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }],
  "Câmara Traseira": [{ nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }],
  "Tampa Traseira":  [{ nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }],
  "Descreve a avaria":[{ nome: "Orçamento Personalizado",       preco: "Sob consulta" }]
},
"redmi-9c": {
  "Display/Touch":   [{ nome: "Substituição de Display/Touch", preco: "69,90€"     }],
  "Bateria":         [{ nome: "Troca de Bateria",             preco: "44,90€"     }],
  "Conector de Carga":[{ nome: "Reparação do Conector de Carga", preco: "Sob consulta" }],
  "Câmara frontal":  [{ nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }],
  "Câmara Traseira": [{ nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }],
  "Tampa Traseira":  [{ nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }],
  "Descreve a avaria":[{ nome: "Orçamento Personalizado",       preco: "Sob consulta" }]
},
  // —— Linha Mi Mix ——
"mi-mix-3": {
  "Display/Touch":   [{ nome: "Substituição de Display/Touch", preco: "Sob consulta" }],
  "Bateria":         [{ nome: "Troca de Bateria",             preco: "Sob consulta" }],
  "Conector de Carga":[{ nome: "Reparação do Conector de Carga", preco: "Sob consulta" }],
  "Câmara frontal":  [{ nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }],
  "Câmara Traseira": [{ nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }],
  "Tampa Traseira":  [{ nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }],
  "Descreve a avaria":[{ nome: "Orçamento Personalizado",       preco: "Sob consulta" }]
},
"mi-mix-2s": {
  "Display/Touch":   [{ nome: "Substituição de Display/Touch", preco: "Sob consulta" }],
  "Bateria":         [{ nome: "Troca de Bateria",             preco: "Sob consulta" }],
  "Conector de Carga":[{ nome: "Reparação do Conector de Carga", preco: "Sob consulta" }],
  "Câmara frontal":  [{ nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }],
  "Câmara Traseira": [{ nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }],
  "Tampa Traseira":  [{ nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }],
  "Descreve a avaria":[{ nome: "Orçamento Personalizado",       preco: "Sob consulta" }]
},
"mi-mix": {
  "Display/Touch":   [{ nome: "Substituição de Display/Touch", preco: "Sob consulta" }],
  "Bateria":         [{ nome: "Troca de Bateria",             preco: "Sob consulta" }],
  "Conector de Carga":[{ nome: "Reparação do Conector de Carga", preco: "Sob consulta" }],
  "Câmara frontal":  [{ nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }],
  "Câmara Traseira": [{ nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }],
  "Tampa Traseira":  [{ nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }],
  "Descreve a avaria":[{ nome: "Orçamento Personalizado",       preco: "Sob consulta" }]
},

// —— Linha Mi A ——
"mi-a3": {
  "Display/Touch":   [{ nome: "Substituição de Display/Touch", preco: "Sob consulta" }],
  "Bateria":         [{ nome: "Troca de Bateria",             preco: "Sob consulta" }],
  "Conector de Carga":[{ nome: "Reparação do Conector de Carga", preco: "Sob consulta" }],
  "Câmara frontal":  [{ nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }],
  "Câmara Traseira": [{ nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }],
  "Tampa Traseira":  [{ nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }],
  "Descreve a avaria":[{ nome: "Orçamento Personalizado",       preco: "Sob consulta" }]
},
"mi-a2": {
  "Display/Touch":   [{ nome: "Substituição de Display/Touch", preco: "Sob consulta" }],
  "Bateria":         [{ nome: "Troca de Bateria",             preco: "Sob consulta" }],
  "Conector de Carga":[{ nome: "Reparação do Conector de Carga", preco: "Sob consulta" }],
  "Câmara frontal":  [{ nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }],
  "Câmara Traseira": [{ nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }],
  "Tampa Traseira":  [{ nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }],
  "Descreve a avaria":[{ nome: "Orçamento Personalizado",       preco: "Sob consulta" }]
},
"mi-a2-lite": {
  "Display/Touch":   [{ nome: "Substituição de Display/Touch", preco: "Sob consulta" }],
  "Bateria":         [{ nome: "Troca de Bateria",             preco: "Sob consulta" }],
  "Conector de Carga":[{ nome: "Reparação do Conector de Carga", preco: "Sob consulta" }],
  "Câmara frontal":  [{ nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }],
  "Câmara Traseira": [{ nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }],
  "Tampa Traseira":  [{ nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }],
  "Descreve a avaria":[{ nome: "Orçamento Personalizado",       preco: "Sob consulta" }]
},
  // —— Linha Xiaomi (parte 1) ——
"xiaomi-14-ultra": {
  "Display/Touch":    [{ nome: "Substituição de Display/Touch", preco: "Sob consulta" }],
  "Bateria":          [{ nome: "Troca de Bateria",             preco: "Sob consulta" }],
  "Conector de Carga": [{ nome: "Reparação do Conector de Carga", preco: "Sob consulta" }],
  "Câmara frontal":   [{ nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }],
  "Câmara Traseira":  [{ nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }],
  "Tampa Traseira":   [{ nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }],
  "Descreve a avaria": [{ nome: "Orçamento Personalizado",       preco: "Sob consulta" }]
},
"xiaomi-13t-pro": {
  "Display/Touch":    [{ nome: "Substituição de Display/Touch", preco: "Sob consulta" }],
  "Bateria":          [{ nome: "Troca de Bateria",             preco: "Sob consulta" }],
  "Conector de Carga": [{ nome: "Reparação do Conector de Carga", preco: "Sob consulta" }],
  "Câmara frontal":   [{ nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }],
  "Câmara Traseira":  [{ nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }],
  "Tampa Traseira":   [{ nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }],
  "Descreve a avaria": [{ nome: "Orçamento Personalizado",       preco: "Sob consulta" }]
},
"xiaomi-13-ultra": {
  "Display/Touch":    [{ nome: "Substituição de Display/Touch", preco: "Sob consulta" }],
  "Bateria":          [{ nome: "Troca de Bateria",             preco: "Sob consulta" }],
  "Conector de Carga": [{ nome: "Reparação do Conector de Carga", preco: "Sob consulta" }],
  "Câmara frontal":   [{ nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }],
  "Câmara Traseira":  [{ nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }],
  "Tampa Traseira":   [{ nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }],
  "Descreve a avaria": [{ nome: "Orçamento Personalizado",       preco: "Sob consulta" }]
},
"xiaomi-13-lite": {
  "Display/Touch":    [{ nome: "Substituição de Display/Touch", preco: "Sob consulta" }],
  "Bateria":          [{ nome: "Troca de Bateria",             preco: "Sob consulta" }],
  "Conector de Carga": [{ nome: "Reparação do Conector de Carga", preco: "Sob consulta" }],
  "Câmara frontal":   [{ nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }],
  "Câmara Traseira":  [{ nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }],
  "Tampa Traseira":   [{ nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }],
  "Descreve a avaria": [{ nome: "Orçamento Personalizado",       preco: "Sob consulta" }]
},
"xiaomi-13-pro": {
  "Display/Touch":    [{ nome: "Substituição de Display/Touch", preco: "Sob consulta" }],
  "Bateria":          [{ nome: "Troca de Bateria",             preco: "Sob consulta" }],
  "Conector de Carga": [{ nome: "Reparação do Conector de Carga", preco: "Sob consulta" }],
  "Câmara frontal":   [{ nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }],
  "Câmara Traseira":  [{ nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }],
  "Tampa Traseira":   [{ nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }],
  "Descreve a avaria": [{ nome: "Orçamento Personalizado",       preco: "Sob consulta" }]
},
"xiaomi-13": {
  "Display/Touch":    [{ nome: "Substituição de Display/Touch", preco: "Sob consulta" }],
  "Bateria":          [{ nome: "Troca de Bateria",             preco: "Sob consulta" }],
  "Conector de Carga": [{ nome: "Reparação do Conector de Carga", preco: "Sob consulta" }],
  "Câmara frontal":   [{ nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }],
  "Câmara Traseira":  [{ nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }],
  "Tampa Traseira":   [{ nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }],
  "Descreve a avaria": [{ nome: "Orçamento Personalizado",       preco: "Sob consulta" }]
},
"xiaomi-12t-pro": {
  "Display/Touch":    [{ nome: "Substituição de Display/Touch", preco: "Sob consulta" }],
  "Bateria":          [{ nome: "Troca de Bateria",             preco: "Sob consulta" }],
  "Conector de Carga": [{ nome: "Reparação do Conector de Carga", preco: "Sob consulta" }],
  "Câmara frontal":   [{ nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }],
  "Câmara Traseira":  [{ nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }],
  "Tampa Traseira":   [{ nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }],
  "Descreve a avaria": [{ nome: "Orçamento Personalizado",       preco: "Sob consulta" }]
},
"xiaomi-12-lite": {
  "Display/Touch":    [{ nome: "Substituição de Display/Touch", preco: "Sob consulta" }],
  "Bateria":          [{ nome: "Troca de Bateria",             preco: "Sob consulta" }],
  "Conector de Carga": [{ nome: "Reparação do Conector de Carga", preco: "Sob consulta" }],
  "Câmara frontal":   [{ nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }],
  "Câmara Traseira":  [{ nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }],
  "Tampa Traseira":   [{ nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }],
  "Descreve a avaria": [{ nome: "Orçamento Personalizado",       preco: "Sob consulta" }]
},

// —— Linha Xiaomi (parte 2) ——
"xiaomi-11i-5g": {
  "Display/Touch":    [{ nome: "Substituição de Display/Touch", preco: "Sob consulta" }],
  "Bateria":          [{ nome: "Troca de Bateria",             preco: "Sob consulta" }],
  "Conector de Carga": [{ nome: "Reparação do Conector de Carga", preco: "Sob consulta" }],
  "Câmara frontal":   [{ nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }],
  "Câmara Traseira":  [{ nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }],
  "Tampa Traseira":   [{ nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }],
  "Descreve a avaria": [{ nome: "Orçamento Personalizado",       preco: "Sob consulta" }]
},
"xiaomi-12-pro": {
  "Display/Touch":    [{ nome: "Substituição de Display/Touch", preco: "Sob consulta" }],
  "Bateria":          [{ nome: "Troca de Bateria",             preco: "Sob consulta" }],
  "Conector de Carga": [{ nome: "Reparação do Conector de Carga", preco: "Sob consulta" }],
  "Câmara frontal":   [{ nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }],
  "Câmara Traseira":  [{ nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }],
  "Tampa Traseira":   [{ nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }],
  "Descreve a avaria": [{ nome: "Orçamento Personalizado",       preco: "Sob consulta" }]
},
"xiaomi-12x": {
  "Display/Touch":    [{ nome: "Substituição de Display/Touch", preco: "Sob consulta" }],
  "Bateria":          [{ nome: "Troca de Bateria",             preco: "Sob consulta" }],
  "Conector de Carga": [{ nome: "Reparação do Conector de Carga", preco: "Sob consulta" }],
  "Câmara frontal":   [{ nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }],
  "Câmara Traseira":  [{ nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }],
  "Tampa Traseira":   [{ nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }],
  "Descreve a avaria": [{ nome: "Orçamento Personalizado",       preco: "Sob consulta" }]
},
"xiaomi-12": {
  "Display/Touch":    [{ nome: "Substituição de Display/Touch", preco: "Sob consulta" }],
  "Bateria":          [{ nome: "Troca de Bateria",             preco: "Sob consulta" }],
  "Conector de Carga": [{ nome: "Reparação do Conector de Carga", preco: "Sob consulta" }],
  "Câmara frontal":   [{ nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }],
  "Câmara Traseira":  [{ nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }],
  "Tampa Traseira":   [{ nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }],
  "Descreve a avaria": [{ nome: "Orçamento Personalizado",       preco: "Sob consulta" }]
},
"xiaomi-11-lite-5g-ne": {
  "Display/Touch":    [{ nome: "Substituição de Display/Touch", preco: "Sob consulta" }],
  "Bateria":          [{ nome: "Troca de Bateria",             preco: "Sob consulta" }],
  "Conector de Carga": [{ nome: "Reparação do Conector de Carga", preco: "Sob consulta" }],
  "Câmara frontal":   [{ nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }],
  "Câmara Traseira":  [{ nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }],
  "Tampa Traseira":   [{ nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }],
  "Descreve a avaria": [{ nome: "Orçamento Personalizado",       preco: "Sob consulta" }]
},
"xiaomi-11t": {
  "Display/Touch":    [{ nome: "Substituição de Display/Touch", preco: "Sob consulta" }],
  "Bateria":          [{ nome: "Troca de Bateria",             preco: "Sob consulta" }],
  "Conector de Carga": [{ nome: "Reparação do Conector de Carga", preco: "Sob consulta" }],
  "Câmara frontal":   [{ nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }],
  "Câmara Traseira":  [{ nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }],
  "Tampa Traseira":   [{ nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }],
  "Descreve a avaria": [{ nome: "Orçamento Personalizado",       preco: "Sob consulta" }]
},
"xiaomi-11t-pro": {
  "Display/Touch":    [{ nome: "Substituição de Display/Touch", preco: "Sob consulta" }],
  "Bateria":          [{ nome: "Troca de Bateria",             preco: "Sob consulta" }],
  "Conector de Carga": [{ nome: "Reparação do Conector de Carga", preco: "Sob consulta" }],
  "Câmara frontal":   [{ nome: "Substituição da Câmara Frontal", preco: "Sob consulta" }],
  "Câmara Traseira":  [{ nome: "Substituição da Câmara Traseira", preco: "Sob consulta" }],
  "Tampa Traseira":   [{ nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }],
  "Descreve a avaria": [{ nome: "Orçamento Personalizado",       preco: "Sob consulta" }]
},
    "xiaomi-11i-5g": {
    "Display/Touch": [
      { nome: "Substituição de Display/Touch", preco: "Sob consulta" }
    ],
    "Bateria": [
      { nome: "Troca de Bateria", preco: "Sob consulta" }
    ],
    "Conector de Carga": [
      { nome: "Reparação do Conector de Carga", preco: "Sob consulta" }
    ],
    "Câmera frontal": [
      { nome: "Substituição da Câmera Frontal", preco: "Sob consulta" }
    ],
    "Câmera Traseira": [
      { nome: "Substituição da Câmera Traseira", preco: "Sob consulta" }
    ],
    "Tampa Traseira": [
      { nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }
    ],
    "Descreve a avaria": [
      { nome: "Orçamento Personalizado", preco: "Sob consulta" }
    ]
  },
  "xiaomi-12-pro": {
    "Display/Touch": [
      { nome: "Substituição de Display/Touch", preco: "Sob consulta" }
    ],
    "Bateria": [
      { nome: "Troca de Bateria", preco: "Sob consulta" }
    ],
    "Conector de Carga": [
      { nome: "Reparação do Conector de Carga", preco: "Sob consulta" }
    ],
    "Câmera frontal": [
      { nome: "Substituição da Câmera Frontal", preco: "Sob consulta" }
    ],
    "Câmera Traseira": [
      { nome: "Substituição da Câmera Traseira", preco: "Sob consulta" }
    ],
    "Tampa Traseira": [
      { nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }
    ],
    "Descreve a avaria": [
      { nome: "Orçamento Personalizado", preco: "Sob consulta" }
    ]
  },
  "xiaomi-12x": {
    "Display/Touch": [
      { nome: "Substituição de Display/Touch", preco: "Sob consulta" }
    ],
    "Bateria": [
      { nome: "Troca de Bateria", preco: "Sob consulta" }
    ],
    "Conector de Carga": [
      { nome: "Reparação do Conector de Carga", preco: "Sob consulta" }
    ],
    "Câmera frontal": [
      { nome: "Substituição da Câmera Frontal", preco: "Sob consulta" }
    ],
    "Câmera Traseira": [
      { nome: "Substituição da Câmera Traseira", preco: "Sob consulta" }
    ],
    "Tampa Traseira": [
      { nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }
    ],
    "Descreve a avaria": [
      { nome: "Orçamento Personalizado", preco: "Sob consulta" }
    ]
  },
  "xiaomi-12": {
    "Display/Touch": [
      { nome: "Substituição de Display/Touch", preco: "Sob consulta" }
    ],
    "Bateria": [
      { nome: "Troca de Bateria", preco: "Sob consulta" }
    ],
    "Conector de Carga": [
      { nome: "Reparação do Conector de Carga", preco: "Sob consulta" }
    ],
    "Câmera frontal": [
      { nome: "Substituição da Câmera Frontal", preco: "Sob consulta" }
    ],
    "Câmera Traseira": [
      { nome: "Substituição da Câmera Traseira", preco: "Sob consulta" }
    ],
    "Tampa Traseira": [
      { nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }
    ],
    "Descreve a avaria": [
      { nome: "Orçamento Personalizado", preco: "Sob consulta" }
    ]
  },
  "xiaomi-11-lite-5g-ne": {
    "Display/Touch": [
      { nome: "Substituição de Display/Touch", preco: "Sob consulta" }
    ],
    "Bateria": [
      { nome: "Troca de Bateria", preco: "Sob consulta" }
    ],
    "Conector de Carga": [
      { nome: "Reparação do Conector de Carga", preco: "Sob consulta" }
    ],
    "Câmera frontal": [
      { nome: "Substituição da Câmera Frontal", preco: "Sob consulta" }
    ],
    "Câmera Traseira": [
      { nome: "Substituição da Câmera Traseira", preco: "Sob consulta" }
    ],
    "Tampa Traseira": [
      { nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }
    ],
    "Descreve a avaria": [
      { nome: "Orçamento Personalizado", preco: "Sob consulta" }
    ]
  },
  "xiaomi-11t": {
    "Display/Touch": [
      { nome: "Substituição de Display/Touch", preco: "Sob consulta" }
    ],
    "Bateria": [
      { nome: "Troca de Bateria", preco: "Sob consulta" }
    ],
    "Conector de Carga": [
      { nome: "Reparação do Conector de Carga", preco: "Sob consulta" }
    ],
    "Câmera frontal": [
      { nome: "Substituição da Câmera Frontal", preco: "Sob consulta" }
    ],
    "Câmera Traseira": [
      { nome: "Substituição da Câmera Traseira", preco: "Sob consulta" }
    ],
    "Tampa Traseira": [
      { nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }
    ],
    "Descreve a avaria": [
      { nome: "Orçamento Personalizado", preco: "Sob consulta" }
    ]
  },
  "xiaomi-11t-pro": {
    "Display/Touch": [
      { nome: "Substituição de Display/Touch", preco: "Sob consulta" }
    ],
    "Bateria": [
      { nome: "Troca de Bateria", preco: "Sob consulta" }
    ],
    "Conector de Carga": [
      { nome: "Reparação do Conector de Carga", preco: "Sob consulta" }
    ],
    "Câmera frontal": [
      { nome: "Substituição da Câmera Frontal", preco: "Sob consulta" }
    ],
    "Câmera Traseira": [
      { nome: "Substituição da Câmera Traseira", preco: "Sob consulta" }
    ],
    "Tampa Traseira": [
      { nome: "Substituição da Tampa Traseira", preco: "Sob consulta" }
    ],
    "Descreve a avaria": [
      { nome: "Orçamento Personalizado", preco: "Sob consulta" }
    ]
  }


};

window.reparacoesData = window.reparacoesData || {};
